/* =====================================================================
   LDM · Comportamiento global de Línea Decor Mueble
   Se carga con defer desde layout/theme.liquid, después de theme.js.
   ===================================================================== */
(function () {
  'use strict';

  /* --- Carruseles .ldm-fc (sections/ldm-featured-collection.liquid): bucle continuo nativo de Owl --- */
  function ldmOwlOptions($, opts) {
    opts = $.extend(true, {}, opts, { loop: true, rewind: false });
    if (opts.responsive && opts.responsive[0]) opts.responsive[0].stagePadding = 24;
    return opts;
  }
  function patchOwl() {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.owlCarousel || $.fn.owlCarousel.__ldm) return;
    var orig = $.fn.owlCarousel;
    var wrapped = function (opts) {
      if (opts && typeof opts === 'object' && this.closest('.ldm-fc').length) {
        var args = [].slice.call(arguments); args[0] = ldmOwlOptions($, opts);
        return orig.apply(this, args);
      }
      return orig.apply(this, arguments);
    };
    for (var k in orig) { if (Object.prototype.hasOwnProperty.call(orig, k)) wrapped[k] = orig[k]; }
    wrapped.Constructor = orig.Constructor; wrapped.__ldm = true;
    $.fn.owlCarousel = wrapped;
  }
  function relaunchOwl() {
    var $ = window.jQuery; if (!$) return;
    $('.ldm-fc .owl-carousel').each(function () {
      var inst = $(this).data('owl.carousel');
      if (inst && !inst.settings.loop) { var o = inst.options; inst.destroy(); $(this).owlCarousel(o); }
    });
  }
  patchOwl();
  document.addEventListener('DOMContentLoaded', patchOwl);
  window.addEventListener('load', function () { patchOwl(); relaunchOwl(); });

  /* --- Botón de WhatsApp (app Squadkin) siempre por encima del aviso de cookies --- */
  function syncWhatsapp() {
    var host = document.querySelector('whatsapp-chat-by-squadkin');
    var box = host && host.shadowRoot && host.shadowRoot.querySelector('.squadkin-wrapper-container');
    if (!box) return;
    if (!box.dataset.ldmBottom) box.dataset.ldmBottom = getComputedStyle(box).bottom;
    var ck = document.getElementById('gdpr-popup-container');
    var st = ck && getComputedStyle(ck);
    var r = ck && ck.offsetHeight ? ck.getBoundingClientRect() : null;
    var visible = r && st.display !== 'none' && st.visibility !== 'hidden' && r.top < window.innerHeight;
    box.style.setProperty('bottom', visible ? Math.round(window.innerHeight - r.top + 12) + 'px' : box.dataset.ldmBottom, 'important');
  }
  var tries = 0, timer = setInterval(function () { syncWhatsapp(); if (++tries > 40) clearInterval(timer); }, 500);
  document.addEventListener('click', function () { setTimeout(syncWhatsapp, 400); }, true);
  window.addEventListener('resize', syncWhatsapp);
})();
